import 'babel-polyfill'

import './js/navigation/index';
import './js/helpers/siteAnimations';
import './js/shareButton/shareButton';
import './js/brandCountriesSelector/brandCountriesSelector';
import './js/storeCount/storeCount';
import {initGraphs} from "./js/graphs/initGraphs";
//
//
//
//
//
//
//
//
//
//
//
//
// //import {initShareholdingStructure} from "./js/shareholdingStructure/initShareholdingStructure";
//
//
//
//
document.addEventListener('DOMContentLoaded', (event) => {
  initGraphs("graph"); // Waiting for AmCharts Library
});
//

//
//
//
//
//
//
//
//
//
//
//
//
// //initShareholdingStructure("shareholding-structure");
//
//
